import { ApiResponse } from 'apisauce';

import api from '@/shared/config/http.config';
import { ErrorInfo } from '@/shared/interfaces/error-info.interface';
import type {
  NotificationRecord,
  NotificationSearchPayload
} from '@/shared/types/notification.types';

/**
 * server.service.notification is a NestJS app. Its controllers return
 * service results directly — there is no `ResponseModel` envelope
 * (`{ data, message }`). The shapes encoded here mirror the actual
 * wire response:
 *
 *   GET /notify/search        → { data: Notification[], total: number }
 *   GET /notify/unread/count  → { count: number }
 *   PATCH /notify/:id/read    → 204 No Content
 *   PATCH /notify/read-all    → 204 No Content
 */
interface NotifySearchResponse {
  data: NotificationRecord[];
  total: number;
}

interface NotifyUnreadCountResponse {
  count: number;
}

const apis = {
  search: (
    payload: NotificationSearchPayload
  ): Promise<ApiResponse<NotifySearchResponse, ErrorInfo>> =>
    api.get('/notify/search', payload as unknown as Record<string, unknown>),

  unreadCount: (
    filter: { platform?: string } = {}
  ): Promise<ApiResponse<NotifyUnreadCountResponse, ErrorInfo>> =>
    api.get('/notify/unread/count', filter as unknown as Record<string, unknown>),

  markRead: (id: string): Promise<ApiResponse<unknown, ErrorInfo>> =>
    api.patch(`/notify/${id}/read`, {}),

  markAllRead: (): Promise<ApiResponse<unknown, ErrorInfo>> => api.patch('/notify/read-all', {})
};

export const notificationsApi = apis;
